document.addEventListener("recommendations-loaded", function () {
    const recommendedProducts = document.querySelectorAll(".recommended-product");

    recommendedProducts.forEach(product => {
        product.querySelector(".product-card--add-to-cart-button").addEventListener("click", function () {
            gtag('event', 'add_to_cart_recommendation', {
                productId: product.dataset.productId,
                quantity: 1,
                add_to_cart_recommendation_quantity: 1
            });
        })

        product.querySelector(".product-cart-item-image").addEventListener("click", function () {
            gtag('event', 'view_product_recommendation', {
                productId: product.dataset.productId
            });
        })
    })
});
